<script setup lang="ts">
/**
 * UI-kit component
 * Category: Links
 * Name: LinkTextSecondaryMedium
 */
import type { LinkTextSecondaryMediumProps } from '../types/interfaces'

import { IconContainer } from '@shared/ui/other'

import { useLinkTextSecondaryMedium } from '../composables/link-text-secondary-medium.hook'

import { NuxtLink } from '#components'

defineOptions({
  name: 'LinkTextSecondaryMedium',
})

const props = withDefaults(defineProps<LinkTextSecondaryMediumProps>(), {
  color: 'blue',
  target: '_self',
  disabled: false,
})

const {
  refIsBlankTarget,
} = useLinkTextSecondaryMedium({ props })
</script>

<template>
  <component
    :is="refIsBlankTarget ? 'a' : NuxtLink"
    :href="refIsBlankTarget ? href : undefined"
    :to="refIsBlankTarget ? null : href"
    :class="['link-text-secondary-medium', color, { disabled }]"
    :target="target"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <slot />
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </component>
</template>

<style lang="scss" scoped src="../styles/_link-text-secondary-medium.scss" />
